import { Control, FieldValues, Path, useController } from 'react-hook-form'
import FieldLayout from "./FieldLayout"
import { Checkbox } from 'antd'

interface CheckboxFieldProps<T extends FieldValues> {
  name: Path<T>
  control: Control<T>
  label?: string
  disabled?: boolean
}

const CheckboxField =  <T extends FieldValues>({ 
  name, 
  control,
  label,
  disabled
}: CheckboxFieldProps<T>) => {
  const { field, fieldState } = useController({ name, control })

  return (
    <FieldLayout
      required={false}
      error={fieldState.error?.message}
    >
      <Checkbox
        onChange={(event) => {
          field.onChange(event.target.checked)
        }}
        defaultChecked={field.value}
        disabled={disabled}
      >
        {label}
      </Checkbox>
    </FieldLayout>
  )
}

export default CheckboxField